import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { SortCriterion } from 'src/shared/api';

export const withMatSort = (sort: MatSort) => ({
	setValue: (
		value?: { sortCriteria?: SortCriterion[] },
		options: { emitEvent: boolean } = { emitEvent: true }
	): void => {
		if (value && value.sortCriteria && value.sortCriteria.length > 0) {
			if (options.emitEvent) {
				sort.sort({
					disableClear: false,
					id: value.sortCriteria[0].sortKey,
					start: value.sortCriteria[0].isDescending ? 'desc' : 'asc',
				});
			} else {
				sort.active = value.sortCriteria[0].sortKey;
				sort.direction = value.sortCriteria[0].isDescending
					? 'desc'
					: 'asc';
			}
		}
	},
	valueChanges: sort.sortChange.pipe(
		map((sortChange) => ({
			sortCriteria: [
				{
					sortKey: sortChange.active,
					isDescending: sortChange.direction === 'desc',
				} as SortCriterion,
			],
			pageNumber: 0,
		}))
	),
});
